export const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
export const distSq = (a, b) => {
	const dx = a.x - b.x;
	const dy = a.y - b.y;
	return dx * dx + dy * dy;
};

export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export const lerp = (a, b, t) => a + (b - a) * t;

export const rand = (min, max) => min + Math.random() * (max - min);

export const pick = (items) => items[Math.floor(Math.random() * items.length)];
